// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__3_j7S","title":"FrontImage_title__1PaQH"};